import React, { useContext } from "react";
import { icons } from "../../../constants";
import { TranslationsContext } from "../../../utils/TranslationsContext";

const UploadError = ({ data, onCloseClick }) => {
  const { t, isLoading } = useContext(TranslationsContext);
  console.log("data", data);
  return (
    <div className="flex-direction-column gap-24 items-center justify-center upload-error-wrapper">
      <div className="flex-direction-row justify-between width-100">
        {" "}
        <p className="inria-sans-400 font-20 modal-title">{t("ERROR")}</p>
        <img
          className="pointer"
          src={icons.close_gray}
          onClick={onCloseClick}
          alt="X"
        />
      </div>
      <div className="flex-direction-column width-100 upload-error">
        {data.map((item, index) => (
          <div
            className="flex-direction-row gap-12 upload-error-row"
            key={index}
          >
            <div
              className="flex-direction-row upload-error-couple"
              style={{ flex: 1 }}
            >
              <p
                className="inria-sans-400 font-14 upload-error-cell id"
                style={{ width: "210px" }}
              >
                {item.ID}
              </p>

              <p
                className="inria-sans-400 font-14 upload-error-cell"
                style={{ flex: 1 }}
              >
                {item.Ime} {item.Prezime}
              </p>
            </div>
            <p className="inria-sans-400 font-14 upload-error-cell status">
              {item.Status}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UploadError;
